import { Component, OnInit } from '@angular/core'
import { PanelService } from '../../services/panel/panel.service'

@Component({
	selector: 'app-qr-code-upload-file-patient',
	templateUrl: './qr-code-upload-file-patient.component.html',
	styleUrls: ['./qr-code-upload-file-patient.component.scss'],
})
export class QrCodeUploadFilePatientComponent implements OnInit {
	private uuid: string = ''
	qrCode: string = ''

	constructor(private panelService: PanelService) {}

	ngOnInit(): void {
		this.qrCode = this.generateQrCode()
	}

	generateQrCode(): string {
		this.getQrCode()
		const { host } = window.location
		const protocol = host.includes('localhost') ? 'http://' : 'https://'

		return `${protocol}${host}/enviar-exames/${this.uuid}`
	}

	getQrCode() {
		this.uuid = <string>localStorage.getItem('session')
			? `${JSON.parse(<string>localStorage.getItem('session')).id}--${JSON.parse(<string>localStorage.getItem('session')).patient.id}`
			: ''
	}
}
